import moment from 'moment';
import find from 'lodash/find';
import {getDaysOfWeek} from 'utils/datetime';
import * as actions from './actions';
import {cloneDeep} from 'lodash';
import {replaceNaNInfinityWithDash} from '../../../../helpers';


export default (state = {}, action) => {
  switch (action.type) {
    case actions.INIT.BEGIN:

      const today = moment().startOf('day');
      const startDateMax = moment(action.sprint.endDate).endOf('day').toDate();
      const endDateMin = moment.max(moment(action.sprint.startDate).startOf('day'), today).toDate();
      const startDateMin = moment(action.sprint.startDateMin).startOf('day').toDate();

      return {
        ...state,
        currentTab: 'general',
        sprintValue: {
          ...action.sprint,
          hourCapacity: Number(action.sprint.capacity) * action.sprint.spToHour,
        },
        startDateMin,
        startDateMax,
        endDateMin,
        hasNext: action.sprint.hasNext,
        nextId: action.sprint.nextId,
        hasPrev: action.sprint.hasPrev,
        prevId: action.sprint.prevId,
        origValues: {
          startDateMax: cloneDeep(startDateMax),
          endDateMin:cloneDeep(endDateMin),
        }
      };
    case actions.INIT.END:
      let selectedTeam;
      if (action.selectedTeam) {
        selectedTeam = action.teamOptions.find(team => team.id === action.selectedTeam.id)
      } else {
        selectedTeam = action.teamOptions && action.teamOptions[0];
      }
      const weekDetails = getDaysOfWeek(action.weekOptions[0].week.start);
      return {
        ...state,
        costOfEstimationModel: action.costOfEstimationModel,
        teamOptions: action.teamOptions,
        weekOptions: action.weekOptions,
        dayOverridesHash: action.dayOverridesHash,
        selectedWeek: action.weekOptions[0],
        selectedTeam,
        weekDetails,
        origValues: {
          ...state.origValues,
          sprintValue: cloneDeep(state.sprintValue),
          selectedTeam: cloneDeep(selectedTeam),
          costOfEstimationModel: action.costOfEstimationModel,
        }
      };
    case actions.SET_TAB:
      return {
        ...state,
        currentTab: action.value,
      };
    case actions.SET_WEEK:
      return {
        ...state,
        selectedWeek: action.value,
        weekDetails: getDaysOfWeek(action.value.week.start),
      };
    case actions.SET_USER_DAY.END:
      return {
        ...state,
        dayOverridesHash: action.dayOverridesHash,
        sprintValue: {
          ...state.sprintValue,
          users: state.sprintValue.users.map(user => user.userId === action.user.userId ? action.user : user)
        }
      };
    case actions.SET_NAME:
      return {
        ...state,
        sprintValue: {
          ...state.sprintValue,
          name: action.value,
        },
      };
    case actions.SET_CAPACITY:
      return {
        ...state,
        sprintValue: {
          ...state.sprintValue,
          capacity: action.value,
          hourCapacity: Number(action.value) * state.sprintValue.spToHour,
        },
      };
    case actions.SET_HOUR_CAPACITY:
      return {
        ...state,
        sprintValue: {
          ...state.sprintValue,
          hourCapacity: action.value,
          capacity: Math.round(Number(action.value) / state.sprintValue.spToHour),
        },
      };
    case actions.RESET:
      return {
        ...state,
        currentTab: 'general',
        weekOptions: [{ id: -1, label: 'loading...' }],
        sprintValue: null,
        selectedWeek: null,
        weekDetails: null,
        dayOverridesHash: null,
      };

    case actions.MEMBERS_UPDATED:
      return {
        ...state,
        sprintValue: {
          ...state.sprintValue,
          users: action.users,
          sprintLenght: action.sprintLenght,
          workingDuration: action.workingDuration
        },
        weekOptions: action.weekOptions,
        dayOverridesHash: action.dayOverridesHash,
        selectedWeek: action.weekOptions[0],
        weekDetails: getDaysOfWeek(action.weekOptions[0].week.start),
      };
    case actions.SET_END_DATE:
      return {
        ...state,
        sprintValue: {
          ...state.sprintValue,
          endDate: action.value,
        },
        startDateMax: moment(action.value).endOf('day').toDate(),
      };
    case actions.SET_START_DATE:
      return {
        ...state,
        sprintValue: {
          ...state.sprintValue,
          startDate: action.value,
        },
        endDateMin: moment(action.value).startOf('day').toDate(),
      };
    case actions.REMOVE:
      return {
        ...state,
        sprintValue: {
          ...state.sprintValue,
          isDeleted: true
        }
      };
    case actions.RESET_CHANGES:
      return {
        ...state,
        ...cloneDeep(state.origValues)
      };

    case actions.SET_COST_OF_ESTIMATION.BEGIN:
      return {
        ...state,
        costOfEstimationModel: action.costOfEstimationModel,
      };
    case actions.SET_COST_OF_ESTIMATION.END:
      return {
        ...state,
        sprintValue: {
          ...state.sprintValue,
          costOfEstimationUnit: action.costOfEstimationUnit
        }
      };
    case actions.SET_COST_OF_ESTIMATION_INHERIT.END:
      return {
        ...state,
        costOfEstimationModel: action.costOfEstimationModel,
        sprintValue: {
          ...state.sprintValue,
          costOfEstUnitInherit: action.costOfEstUnitInherit
        },
      };
    case actions.RECALCULATE_HOURS.END:
    case actions.RECALCULATE_SP.END:
    case actions.SET_WORKING_DURATION.END:
      return {
        ...state,
        sprintValue: {
          ...state.sprintValue,
          users: state.sprintValue.users.map(user => user.userId === action.user.userId ? action.user : user)
        }
      };
    case actions.RECALCULATE_RECOMMENDED_CAPACITY:
      const recommendedCapacity = state.sprintValue.users.map(user => user.totalSp).reduce((prev, next) => prev + Number(next), 0);

      return {
        ...state,
        recommendedCapacity: replaceNaNInfinityWithDash(recommendedCapacity.toFixed(1)),
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/sprint/fieldset/reducer.js